var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLogout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 1.75H13.125C13.5891 1.75 14.0342 1.93437 14.3624 2.26256C14.6906 2.59075 14.875 3.03587 14.875 3.5V5.25H13.125V3.5H5.25V17.5H13.125V15.75H14.875V17.5C14.875 17.9641 14.6906 18.4092 14.3624 18.7374C14.0342 19.0656 13.5891 19.25 13.125 19.25H5.25C4.78587 19.25 4.34075 19.0656 4.01256 18.7374C3.68437 18.4092 3.5 17.9641 3.5 17.5V3.5C3.5 3.03587 3.68437 2.59075 4.01256 2.26256C4.34075 1.93437 4.78587 1.75 5.25 1.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0788 13.6413L15.3125 14.875L19.6875 10.5L15.3125 6.125L14.0788 7.35875L16.3363 9.625H7.875V11.375H16.3363L14.0788 13.6413Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogout);
export default __webpack_public_path__ + "static/media/ic_logout.c5ad13238227f530b0fe3fd27554928d.svg";
export { ForwardRef as ReactComponent };